export interface CountryConfig {
  code: string;
  name: string;
  flag: string;
  phonePrefix: string;
  phoneLength: number;
  phonePlaceholder: string;
  plateRegEx: RegExp;
  platePlaceholder: string;
  plateFormatHelp: string;
  idLabel?: string;
}

export const COUNTRIES_CONFIG: Record<string, CountryConfig> = {
  CO: {
    code: 'CO',
    name: 'Colombia',
    flag: '🇨🇴',
    phonePrefix: '57',
    phoneLength: 10,
    phonePlaceholder: '312 345 6789',
    plateRegEx: /^[A-Z]{3}[0-9]{3}$|^[A-Z]{3}[0-9]{2}[A-Z]$/,
    platePlaceholder: 'AAA11A',
    plateFormatHelp: 'Usa formato clásico (AAA111) o moto (AAA11A).',
    idLabel: 'N° Cédula'
  },
  MX: {
    code: 'MX',
    name: 'México',
    flag: '🇲🇽',
    phonePrefix: '52',
    phoneLength: 10,
    phonePlaceholder: '55 1234 5678',
    plateRegEx: /^[A-Z0-9]{5,8}$/,
    platePlaceholder: '12AAA1',
    plateFormatHelp: 'Ingresa una placa válida de 5 a 8 caracteres alfanuméricos.',
    idLabel: 'INE / CURP'
  },
  AR: {
    code: 'AR',
    name: 'Argentina',
    flag: '🇦🇷',
    phonePrefix: '54',
    phoneLength: 10,
    phonePlaceholder: '11 1234 5678',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'A012ABC',
    plateFormatHelp: 'Usa formato clásico (AAA111) o Mercosur (A012ABC / A111AAA).',
    idLabel: 'DNI / CUIL'
  },
  PE: {
    code: 'PE',
    name: 'Perú',
    flag: '🇵🇪',
    phonePrefix: '51',
    phoneLength: 9,
    phonePlaceholder: '912 345 678',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: '1234AB',
    plateFormatHelp: 'Usa formato clásico de Perú (ej: 1234AB o ABC123).',
    idLabel: 'N° DNI'
  },
  EC: {
    code: 'EC',
    name: 'Ecuador',
    flag: '🇪🇨',
    phonePrefix: '593',
    phoneLength: 9,
    phonePlaceholder: '91 234 5678',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'ABC1234',
    plateFormatHelp: 'Ingresa formato de placa de Ecuador (ej: ABC1234 o AB1234).',
    idLabel: 'Cédula de Identidad'
  },
  CL: {
    code: 'CL',
    name: 'Chile',
    flag: '🇨🇱',
    phonePrefix: '56',
    phoneLength: 9,
    phonePlaceholder: '9 1234 5678',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'AA1111',
    plateFormatHelp: 'Ingresa una placa chilena válida de 3 a 8 caracteres (ej: AA1111 o AAAA11).',
    idLabel: 'RUT'
  },
  VE: {
    code: 'VE',
    name: 'Venezuela',
    flag: '🇻🇪',
    phonePrefix: '58',
    phoneLength: 10,
    phonePlaceholder: '412 123 4567',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'AI123A',
    plateFormatHelp: 'Usa un formato de placa venezolana válido.',
    idLabel: 'Cédula (C.I.)'
  },
  BO: {
    code: 'BO',
    name: 'Bolivia',
    flag: '🇧🇴',
    phonePrefix: '591',
    phoneLength: 8,
    phonePlaceholder: '7123 4567',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: '1234ABC',
    plateFormatHelp: 'Usa formato clásico boliviano (ej: 1234ABC).',
    idLabel: 'Carnet Identidad'
  },
  UY: {
    code: 'UY',
    name: 'Uruguay',
    flag: '🇺🇾',
    phonePrefix: '598',
    phoneLength: 9,
    phonePlaceholder: '99 123 456',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'SAB1234',
    plateFormatHelp: 'Usa formato uruguayo de 3 letras y 4 números (SAB1234).',
    idLabel: 'Cédula (C.I.)'
  },
  PY: {
    code: 'PY',
    name: 'Paraguay',
    flag: '🇵🇾',
    phonePrefix: '595',
    phoneLength: 9,
    phonePlaceholder: '981 123 456',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'ABC123',
    plateFormatHelp: 'Usa formato de placa paraguayo o Mercosur.',
    idLabel: 'Cédula (C.I.)'
  },
  PA: {
    code: 'PA',
    name: 'Panamá',
    flag: '🇵🇦',
    phonePrefix: '507',
    phoneLength: 8,
    phonePlaceholder: '6123 4567',
    plateRegEx: /^[A-Z0-9]{3,8}$/,
    platePlaceholder: 'AB1234',
    plateFormatHelp: 'Ingresa formato de placa panameña (ej: AB1234).',
    idLabel: 'Cédula'
  },
  CR: {
    code: 'CR',
    name: 'Costa Rica',
    flag: '🇨🇷',
    phonePrefix: '506',
    phoneLength: 8,
    phonePlaceholder: '8123 4567',
    plateRegEx: /^[A-Z0-9]{1,8}$/,
    platePlaceholder: 'M123456',
    plateFormatHelp: 'Ingresa una placa válida de Costa Rica (ej: M123456).',
    idLabel: 'Cédula'
  },
  SV: {
    code: 'SV',
    name: 'El Salvador',
    flag: '🇸🇻',
    phonePrefix: '503',
    phoneLength: 8,
    phonePlaceholder: '7123 4567',
    plateRegEx: /^[A-Z0-9]{1,8}$/,
    platePlaceholder: 'M12345',
    plateFormatHelp: 'Ingresa una placa válida de El Salvador.',
    idLabel: 'N° Identidad'
  },
  GT: {
    code: 'GT',
    name: 'Guatemala',
    flag: '🇬🇹',
    phonePrefix: '502',
    phoneLength: 8,
    phonePlaceholder: '5123 4567',
    plateRegEx: /^[A-Z0-9]{1,8}$/,
    platePlaceholder: 'M123ABC',
    plateFormatHelp: 'Ingresa una placa válida de Guatemala.',
    idLabel: 'N° CUI / DPI'
  },
  HN: {
    code: 'HN',
    name: 'Honduras',
    flag: '🇭🇳',
    phonePrefix: '504',
    phoneLength: 8,
    phonePlaceholder: '9123 4567',
    plateRegEx: /^[A-Z0-9]{1,8}$/,
    platePlaceholder: 'MAB1234',
    plateFormatHelp: 'Ingresa una placa válida de Honduras.',
    idLabel: 'N° DNI'
  },
  NI: {
    code: 'NI',
    name: 'Nicaragua',
    flag: '🇳🇮',
    phonePrefix: '505',
    phoneLength: 8,
    phonePlaceholder: '8123 4567',
    plateRegEx: /^[A-Z0-9]{1,8}$/,
    platePlaceholder: 'M123456',
    plateFormatHelp: 'Ingresa una placa válida de Nicaragua.',
    idLabel: 'N° Cédula'
  }
};
